import React from 'react';
import cn from 'clsx';

import Link from '../../library/link/link';
import Tooltip from '../../library/tooltip/tooltip';
import Typography from '../../library/typography/typography';
import GroupAffiliationPromotionIdMeButton from '../group-affiliation-promotion-id-me-button/group-affiliation-promotion-id-me-button';
import GroupAffiliationPromotionTitle from '../group-affiliation-promotion-title/group-affiliation-promotion-title';

import { useGroupAffiliation } from '../../shared/hooks/hooks';

import styles from './group-affiliation-promotion.scss';

interface GroupAffiliationPromotionProps {
  className?: string;
  onRefresh?: () => void;
  showAppliedDiscount?: boolean;
  showTitle?: boolean;
}

function GroupAffiliationPromotion(props: GroupAffiliationPromotionProps) {
  const { className, onRefresh, showAppliedDiscount, showTitle } = props;
  const {
    groupAffiliationPromotion,
    isAppliedPromotion,
    openVerificationWindow,
    promotion
  } = useGroupAffiliation({
    onRefresh
  });

  const {
    verificationDiscountAppliedMessage,
    verificationSuccessMessage,
    verificationSuccessTooltipMessage
  } = groupAffiliationPromotion || {};

  return (
    <div className={className}>
      <GroupAffiliationPromotionTitle
        className={styles['title']}
        showTitle={showTitle}
        title="Deals"
      />
      <div
        className={cn(
          showAppliedDiscount
            ? styles['content']
            : styles['content-no-discount'],
          'group-affiliation-promotion__content-no-discount'
        )}
      >
        <div
          className={
            showAppliedDiscount
              ? styles['description']
              : styles['description-no-discount']
          }
        >
          <Typography
            className={cn(
              styles['description-text'],
              'group-affiliation-promotion__description-text'
            )}
            size="small"
            tag="div"
          >
            {promotion?.description}
          </Typography>
          {promotion?.detailsUrl && (
            <Link
              className="group-affiliation-promotion__link"
              target="_blank"
              to={promotion.detailsUrl}
            >
              learn more about this discount
            </Link>
          )}
        </div>

        {isAppliedPromotion && showAppliedDiscount && (
          <div className={styles['applied-discount']}>
            <Typography
              className={styles['applied-discount-message']}
              size="small"
              tag="div"
            >
              {verificationSuccessMessage}
              <Tooltip
                className={styles['applied-tooltip']}
                content={verificationSuccessTooltipMessage}
              />
            </Typography>

            <span className={styles['discount-price']}>
              {verificationDiscountAppliedMessage}
            </span>
          </div>
        )}

        {isAppliedPromotion && !showAppliedDiscount && (
          <div className={styles['applied-promotion-message']}>
            {verificationSuccessMessage}
            <Tooltip
              className={styles['applied-tooltip']}
              content={verificationSuccessTooltipMessage}
            />
          </div>
        )}

        <GroupAffiliationPromotionIdMeButton
          isAppliedPromotion={isAppliedPromotion}
          openVerificationWindow={openVerificationWindow}
        />
      </div>
    </div>
  );
}

export default GroupAffiliationPromotion;
